/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { configInterceptor } from '@wec-core/interceptor';
import isFeatureFlagEnabled from '../../helpers/feature-flags';
import { GATEMANAGER } from '../../types/featureFlag.types';
import { useDispatch } from 'react-redux';
import { pushApiLog } from '../../reducers/logs';

const useInterceptor = (): void => {
  const dispatch = useDispatch();

  useEffect(() => {
    configInterceptor({
      responseCallback: async (response, responseJson) => {
        if (isFeatureFlagEnabled(GATEMANAGER)) {
          if (responseJson?.code === '3100') {
            window.open(responseJson?.wait_page_redirect_url, '_self');
          }
        }
        dispatch(pushApiLog({ url: response?.url, status: response?.status }));
      },
      errorCallback: error => {
        dispatch(
          pushApiLog({ url: error?.data?.url, status: error?.data?.status })
        );
        console.log('interceptor error handling', error);
      }
    });
  }, []);
};

export default useInterceptor;
